// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  grantId: __t.u64().primaryKey().name("grant_id"),
  requestId: __t.u64().name("request_id"),
  userIdentity: __t.identity().name("user_identity"),
  agentIdentity: __t.identity().name("agent_identity"),
  audience: __t.string(),
  accessToken: __t.string().name("access_token"),
  expiresAtMs: __t.u64().name("expires_at_ms"),
  grantedAt: __t.timestamp().name("granted_at"),
});
